document.cookie = `browser_time_zone=${Intl.DateTimeFormat().resolvedOptions().timeZone}; path=/; SameSite=strict`
